module.exports = __webpack_public_path__ + "static/2front-hasta-2-513069fb9fc8cb8b4d60cc8561d518c9.png";